/* dn-search : recherche intelligente Donicars (véhicule + année + type d'ampoule).
   - Comprend « alfa romeo giulia », « clio 4 2013 », « h7 golf 7 », « t10 »…
   - Propose les générations d'un modèle (« Quelle année ? ») à partir de l'index des collections véhicule (dn-vehicles.js).
   - Filtre côté navigateur les produits hors sujet renvoyés par la recherche prédictive Shopify.
   Aucune donnée personnelle n'est collectée ; seuls des appels à /search/suggest.json (même domaine). */
(function (g, factory) {
  var api = factory(g);
  if (typeof module === 'object' && module.exports) { module.exports = api; }
  else { g.DNSearch = api; if (typeof document !== 'undefined') api.boot(); }
})(typeof window !== 'undefined' ? window : globalThis, function (g) {
  'use strict';

  var ROMAN = { ii: '2', iii: '3', iv: '4', vi: '6', vii: '7', viii: '8', ix: '9' };
  var STOP = {};
  ('ampoule ampoules led leds pack packs kit kits pour de du des la le les un une et au aux en sur avec sans lot lampe lampes ' +
   'gluhbirne gluhbirnen birne birnen lampen fur fuer set paket mit ohne und ' +
   'bombilla bombillas para con sin paquete ' +
   'lampadina lampadine per senza confezione ' +
   'lamp voor met zonder ' +
   'zarowka zarowki do dla bez zestaw ' +
   'lampada lampadas conjunto ' +
   'lampa lampor med utan och ' +
   'pare paere lyspaere til uten sett ' +
   'polttimo polttimot lamppu varten ja setti ' +
   'izzo izzok es keszlet').split(' ').forEach(function (w) { STOP[w] = 1; });
  var BULB = /^(h\d{1,2}[a-z]?|hb\d|hir\d|hs\d|t\d{1,2}|w\d{1,2}w|p\d{1,2}w|py\d{1,2}w|r\d{1,2}w|c\d{1,2}w|d\d[srt]|ba\d{1,2}s|bay\d{1,2}d)$/;
  var YEAR = /^(19[6-9]\d|20[0-3]\d)$/;
  var MAXY = 2030;

  function norm(s) {
    return String(s == null ? '' : s).toLowerCase()
      .replace(/ß/g, 'ss').replace(/ø/g, 'o').replace(/æ/g, 'ae').replace(/ł/g, 'l').replace(/đ/g, 'd')
      .normalize('NFD').replace(/[̀-ͯ]/g, '')
      .replace(/[^a-z0-9]+/g, ' ').trim();
  }
  function stem(t) { return (t.length > 3 && /[sx]$/.test(t)) ? t.slice(0, -1) : t; }
  function tokens(s) {
    var raw = norm(s).split(' ').filter(Boolean).map(function (t) { return ROMAN[t] || t; });
    var out = [];
    for (var i = 0; i < raw.length; i++) {            // « a 3 » -> « a3 », « x 5 » -> « x5 »
      if (raw[i].length === 1 && /^[a-z]$/.test(raw[i]) && i + 1 < raw.length && /^\d{1,2}$/.test(raw[i + 1])) { out.push(raw[i] + raw[i + 1]); i++; }
      else { out.push(raw[i]); }
    }
    return out;
  }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }

  /* ---------- Analyse de la requête ---------- */
  function parse(q) {
    var out = { raw: String(q || ''), toks: tokens(q), veh: [], bulbs: [], year: null };
    out.toks.forEach(function (t) {
      if (YEAR.test(t)) { out.year = +t; }
      else if (BULB.test(t)) { out.bulbs.push(t); }
      else if (!STOP[t]) { out.veh.push(t); }
    });
    return out;
  }

  /* ---------- Véhicules ---------- */
  var cache = null;
  function vehicles() {
    if (!g.DN_VEH) return null;
    if (!cache) {
      cache = g.DN_VEH.map(function (r) {
        return { b: r[0], m: r[1], y1: r[2], y2: r[3], h: r[4], n: r[5], d: r[6], t: tokens(r[0] + ' ' + r[1] + ' ' + r[6]) };   // + code châssis du titre (E92, W176, 8V…)
      });
    }
    return cache;
  }
  function matchEntry(e, qt, prefixLast) {
    for (var i = 0; i < qt.length; i++) {
      var q = qt[i], ok = false;
      for (var j = 0; j < e.t.length; j++) {
        var t = e.t[j];
        if (t === q || stem(t) === stem(q) || (prefixLast && i === qt.length - 1 && q.length >= 2 && t.indexOf(q) === 0)) { ok = true; break; }
      }
      if (!ok) return false;
    }
    return true;
  }
  function covers(e, y) { return e.y1 <= y && y <= (e.y2 || MAXY); }

  function findVehicles(p) {
    var list = vehicles();
    var res = { mode: 'none', items: [], prefix: false, yearApplied: false, yearMiss: false, brand: null, families: [] };
    if (!list || !p.veh.length) return res;
    var jq = p.veh.join('');
    if (jq.length < 3 && !(jq.length >= 2 && /\d/.test(jq))) return res;
    var items = list.filter(function (e) { return matchEntry(e, p.veh, false); });
    if (!items.length) { items = list.filter(function (e) { return matchEntry(e, p.veh, true); }); res.prefix = true; }
    if (!items.length) return res;
    var brands = {}; items.forEach(function (e) { brands[e.b] = 1; });
    var brandKeys = Object.keys(brands);
    // Requête = seulement la marque ?
    var onlyBrand = brandKeys.length === 1 && p.veh.every(function (q, i) {
      var bt = tokens(brandKeys[0]);
      return bt.some(function (t) { return t === q || stem(t) === stem(q) || (i === p.veh.length - 1 && q.length >= 2 && t.indexOf(q) === 0); });
    });
    if (onlyBrand && !p.year) {
      res.mode = 'brand'; res.brand = brandKeys[0];
      var fam = {};
      items.forEach(function (e) {
        var key = e.m.split(' ')[0] === 'serie' || e.m.split(' ')[0] === 'classe' ? e.m.split(' ').slice(0, 2).join(' ') : e.m.split(' ')[0];
        (fam[key] = fam[key] || { name: key, n: 0, gens: 0 });
        fam[key].n += e.n; fam[key].gens++;
      });
      res.families = Object.keys(fam).map(function (k) { return fam[k]; }).sort(function (a, b) { return b.n - a.n; }).slice(0, 14);
      res.items = items;
      return res;
    }
    if (brandKeys.length > 3 && res.prefix) return res;     // préfixe trop ambigu
    if (p.year) {
      var cov = items.filter(function (e) { return covers(e, p.year); });
      if (cov.length) { items = cov; res.yearApplied = true; } else { res.yearMiss = true; }
    }
    items.sort(function (a, b) { return (b.n - a.n) || (b.y1 - a.y1); });
    res.mode = 'models'; res.items = items.slice(0, 8);
    return res;
  }

  /* ---------- Produits (filtrage anti-bruit) ---------- */
  function titleYears(title) {
    var m = /(19[6-9]\d|20[0-3]\d)\s*(?:à|a|-|–|bis|to)\s*(19[6-9]\d|20[0-3]\d)?/i.exec(title);
    if (m) return [+m[1], m[2] ? +m[2] : MAXY];
    return null;
  }
  function productOk(title, p, prefix) {
    var tt = tokens(title);
    function has(q, last) {
      return tt.some(function (e) { return e === q || stem(e) === stem(q) || (last && prefix && q.length >= 2 && e.indexOf(q) === 0); });
    }
    var okV = p.veh.every(function (q, i) { return has(q, i === p.veh.length - 1); });
    var okB = p.bulbs.every(function (b) { return has(b, false); });
    return okV && okB;
  }
  function rankProducts(list, p) {
    return list.map(function (x, i) {
      var t = x.title || '', s = 0;
      if (/^(pack|kit|ampoules?)\b/i.test(t)) s += 1;
      if (p.bulbs.length && productOk(t, { veh: [], bulbs: p.bulbs }, false)) s += 2;
      if (p.year) { var y = titleYears(t); if (y && y[0] <= p.year && p.year <= y[1]) s += 2; }
      return { x: x, s: s, i: i };
    }).sort(function (a, b) { return (b.s - a.s) || (a.i - b.i); }).map(function (r) { return r.x; });
  }
  function shopifyQuery(p) {
    var q = p.veh.concat(p.bulbs).join(' ');
    return q || p.raw;
  }

  /* ---------- Rendu ---------- */
  var I18N = (g.DN_SEARCH && g.DN_SEARCH.i18n) || {};
  function T(k, v) {
    var s = I18N[k] || k;
    if (v) Object.keys(v).forEach(function (n) { s = s.split('{' + n + '}').join(v[n]); });
    return s;
  }
  function root() { return (g.Shopify && g.Shopify.routes && g.Shopify.routes.root) || '/'; }
  function yrs(e) { return e.y2 ? T('range', { a: e.y1, b: e.y2 }) : T('since', { a: e.y1 }); }
  function cap(s) { return s.charAt(0).toUpperCase() + s.slice(1); }
  function money(v) {
    var n = parseFloat(v); if (isNaN(n)) return '';
    try { return new Intl.NumberFormat(document.documentElement.lang || 'fr', { style: 'currency', currency: (g.Shopify && g.Shopify.currency && g.Shopify.currency.active) || 'EUR' }).format(n); }
    catch (e) { return n.toFixed(2); }
  }
  function example(items) {
    var e = null;
    (items || []).forEach(function (x) { if (!e || (x.y2 || x.y1) > (e.y2 || e.y1)) e = x; });
    if (!e) return '';
    var y = e.y2 ? Math.round((e.y1 + e.y2) / 2) : e.y1;
    return e.d.replace(/\s*\(.*$/, '').trim() + ' ' + y;
  }

  function vehicleHtml(p, v) {
    var h = '';
    if (v.mode === 'brand') {
      h += '<div class="dn-sec"><div class="dn-h">' + esc(T('which_model')) + ' <b>' + esc(v.brand) + '</b></div><div class="dn-chips">';
      v.families.forEach(function (f) {
        h += '<button type="button" class="dn-chip" data-q="' + esc(v.brand + ' ' + f.name) + ' ">' + esc(cap(f.name)) + '</button>';
      });
      h += '</div></div>';
    } else if (v.mode === 'models') {
      h += '<div class="dn-sec"><div class="dn-h">' + esc(T('veh')) + '</div>';
      if (v.yearMiss) { h += '<div class="dn-note">' + esc(T('year_miss', { y: p.year })) + '</div>'; }
      v.items.forEach(function (e) {
        var name = e.d;
        h += '<a class="dn-veh" href="' + esc(root() + 'collections/' + e.h) + '"><span class="dn-veh-n">' + esc(name) +
             '</span><span class="dn-veh-y">' + esc(yrs(e)) + '</span><span class="dn-veh-go">' + esc(T('see')) + ' &rarr;</span></a>';
      });
      if (!p.year && v.items.length > 1) {
        h += '<div class="dn-tip">' + esc(T('which_year')) + ' ' + esc(T('tip_year', { ex: example(v.items) })) + '</div>';
      }
      h += '</div>';
    }
    return h;
  }
  function bulbHint(p, v) {
    if (p.bulbs.length && !p.veh.length && v.mode === 'none') {
      return '<div class="dn-tip dn-tip--bulb">' + esc(T('bulb_hint')) + '</div>';
    }
    return '';
  }
  function productsHtml(list) {
    if (!list.length) return '';
    var h = '<div class="dn-sec"><div class="dn-h">' + esc(T('products')) + '</div>';
    list.forEach(function (x) {
      var img = x.image || (x.featured_image && x.featured_image.url) || '';
      h += '<a class="dn-prod" href="' + esc(x.url) + '">' + (img ? '<img src="' + esc(img) + '" alt="" loading="lazy" width="44" height="44">' : '<span class="dn-ph"></span>') +
           '<span class="dn-prod-t">' + esc(x.title) + '</span><span class="dn-prod-p">' + esc(money(x.price)) + '</span></a>';
    });
    return h + '</div>';
  }
  function guidesHtml(list) {
    if (!list.length) return '';
    var h = '<div class="dn-sec"><div class="dn-h">' + esc(T('guides')) + '</div>';
    list.forEach(function (x) { h += '<a class="dn-guide" href="' + esc(x.url) + '">' + esc(x.title) + '</a>'; });
    return h + '</div>';
  }

  /* ---------- Orchestration ---------- */
  var reqId = 0, ctl = null;
  function suggest(p, cb) {
    if (ctl && ctl.abort) ctl.abort();
    ctl = (typeof AbortController !== 'undefined') ? new AbortController() : null;
    var url = root() + 'search/suggest.json?q=' + encodeURIComponent(shopifyQuery(p)) +
      '&resources[type]=product,article&resources[limit]=10&resources[limit_scope]=each&resources[options][unavailable_products]=last';
    fetch(url, { signal: ctl ? ctl.signal : undefined, headers: { 'Accept': 'application/json' } })
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); })
      .then(function (j) { cb(null, (j.resources && j.resources.results) || {}); })
      .catch(function (e) { if (!e || e.name !== 'AbortError') cb(e || new Error('x')); });
  }
  function collProducts(handle, cb) {
    fetch(root() + 'collections/' + handle + '/products.json?limit=12', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); })
      .then(function (j) {
        cb(null, (j.products || []).map(function (x) {
          var pr = x.variants && x.variants[0] && x.variants[0].price;
          return { title: x.title, url: root() + 'products/' + x.handle, image: x.images && x.images[0] && x.images[0].src, price: pr };
        }));
      })
      .catch(function (e) { cb(e || new Error('c')); });
  }
  function matchCount(title, toks) {
    var tt = tokens(title), n = 0;
    toks.forEach(function (q) { if (tt.some(function (e) { return e === q || stem(e) === stem(q); })) n++; });
    return n;
  }
  var LANDING = { h7: 'pages/pack-ampoules-led-h7' };
  function render(panel, input, q) {
    var id = ++reqId;
    var p = parse(q);
    if (norm(q).length < 2) { close(panel); return; }
    var v = findVehicles(p);
    var bulbOnly = p.bulbs.length > 0 && !p.veh.length && v.mode === 'none';
    var head = vehicleHtml(p, v) + bulbHint(p, v);
    if (bulbOnly && p.bulbs.length === 1 && LANDING[p.bulbs[0]]) {
      head += '<a class="dn-veh" href="' + esc(root() + LANDING[p.bulbs[0]]) + '"><span class="dn-veh-n">' + esc(T('find_pack')) + '</span><span class="dn-veh-go">' + esc(T('see')) + ' &rarr;</span></a>';
    }
    panel.innerHTML = head + '<div class="dn-loading" aria-hidden="true"></div>';
    open(panel);
    var single = (v.mode === 'models' && v.items.length === 1) ? v.items[0] : null;
    var allTok = p.veh.concat(p.bulbs);
    suggest(p, function (err, res) {
      if (id !== reqId) return;
      var prods = (res && res.products) || [], arts = (res && res.articles) || [];
      var strict = prods.filter(function (x) { return productOk(x.title, p, v.prefix || false); });
      if (!strict.length && v.mode === 'none') {
        if (!allTok.length) { strict = prods; }
        else {                                   // mots-clés libres : au moins la moitié des mots dans le titre
          var need = Math.max(1, Math.ceil(allTok.length / 2));
          strict = prods.filter(function (x) { return matchCount(x.title, allTok) >= need; })
            .sort(function (a, b) { return matchCount(b.title, allTok) - matchCount(a.title, allTok); });
        }
      }
      var g2 = arts.filter(function (x) { return productOk(x.title, { veh: p.veh, bulbs: [] }, v.prefix || false); }).slice(0, 2);
      if (v.mode === 'brand') { strict = []; g2 = []; }
      function finish(list) {
        if (id !== reqId) return;
        if (bulbOnly && LANDING[p.bulbs[0]]) { list = []; }
        else if (bulbOnly) { list = list.slice().sort(function (a, b) { return a.title.length - b.title.length; }).slice(0, 3); }
        else { list = rankProducts(list, p).slice(0, 4); }
        var html = head;
        if (list.length) { html += productsHtml(list); }
        html += guidesHtml(g2);
        if (!list.length && !g2.length && v.mode === 'none' && !(bulbOnly && LANDING[p.bulbs[0]])) { html += '<div class="dn-none">' + esc(T('none')) + '</div>'; }
        html += '<a class="dn-all" href="' + esc(searchUrl(q)) + '">' + esc(T('all', { q: q.trim() })) + ' &rarr;</a>';
        panel.innerHTML = html;
        open(panel);
      }
      if (single) {
        collProducts(single.h, function (e2, cp) {
          var list = (!e2 && cp) ? cp.filter(function (x) { return p.bulbs.every(function (b) { return productOk(x.title, { veh: [], bulbs: [b] }, false); }); }) : [];
          finish(list.length ? list : strict);
        });
      } else { finish(strict); }
    });
  }
  function searchUrl(q) {
    return root() + 'search?type=product&options%5Bprefix%5D=last&q=' + encodeURIComponent(q.trim());
  }
  function open(panel) { panel.classList.add('active', 'dn-open'); panel.style.display = 'block'; }
  function close(panel) { panel.classList.remove('active', 'dn-open'); panel.style.display = 'none'; panel.innerHTML = ''; }
  function debounce(fn, ms) { var t; return function () { var a = arguments, c = this; clearTimeout(t); t = setTimeout(function () { fn.apply(c, a); }, ms); }; }

  var dataPromise = null;
  function loadData() {
    if (g.DN_VEH) return Promise.resolve();
    if (dataPromise) return dataPromise;
    dataPromise = new Promise(function (ok) {
      var url = g.DN_SEARCH && g.DN_SEARCH.vehUrl; if (!url) { ok(); return; }
      var s = document.createElement('script'); s.src = url; s.async = true; s.onload = ok; s.onerror = ok; document.head.appendChild(s);
    });
    return dataPromise;
  }

  function initForm(form) {
    var input = form.querySelector('input[name="q"]');
    if (!input || input.getAttribute('data-dn')) return;
    input.setAttribute('data-dn', '1');
    input.setAttribute('autocomplete', 'off');
    // Le thème efface le champ à chaque focus (onfocus="this.value=''") : cela vidait la saisie en cliquant sur une pastille ou en revenant dans le champ.
    input.removeAttribute('onfocus'); input.onfocus = null;
    var panel = form.querySelector('.search-results');
    if (!panel) { panel = document.createElement('div'); panel.className = 'search-results'; form.appendChild(panel); }
    panel.classList.add('dn-sr'); panel.setAttribute('aria-live', 'polite');
    function go() { loadData().then(function () { render(panel, input, input.value); }); }
    input.addEventListener('focus', function () {
      // retour dans le champ avec du texte déjà saisi : on réaffiche les suggestions (sans rien effacer)
      loadData().then(function () { if (norm(input.value).length >= 2 && !panel.classList.contains('dn-open')) { render(panel, input, input.value); } });
    });
    input.addEventListener('input', debounce(go, 160));
    input.addEventListener('keydown', function (e) { if (e.key === 'Escape') { close(panel); } });
    panel.addEventListener('click', function (e) {
      var b = e.target.closest && e.target.closest('.dn-chip');
      if (b) { e.preventDefault(); input.value = b.getAttribute('data-q'); input.focus(); try { input.setSelectionRange(input.value.length, input.value.length); } catch (x) {} go(); }
    });
    form.addEventListener('submit', function () {
      if (!form.querySelector('input[name="options[prefix]"]')) {
        var h = document.createElement('input'); h.type = 'hidden'; h.name = 'options[prefix]'; h.value = 'last'; form.appendChild(h);
      }
      // L'année et les mots vides sont retirés de la requête envoyée à Shopify (sinon « clio 4 2013 » exclut les fiches « 2012 à 2019 ») ;
      // la requête d'origine est gardée dans dnq pour le panneau véhicule de la page de résultats.
      var p = parse(input.value);
      if (p.year && p.veh.length) {
        var d = form.querySelector('input[name="dnq"]');
        if (!d) { d = document.createElement('input'); d.type = 'hidden'; d.name = 'dnq'; form.appendChild(d); }
        d.value = input.value;
        input.value = shopifyQuery(p);
      }
    });
    document.addEventListener('click', function (e) { if (!form.contains(e.target)) { close(panel); } });
  }

  function initPage() {
    var host = document.getElementById('dn-search-page');
    if (!host) return;
    var q = host.getAttribute('data-q') || '';
    try { var u = new URLSearchParams(location.search).get('dnq'); if (u) q = u; } catch (e) {}
    loadData().then(function () {
      var p = parse(q), v = findVehicles(p);
      var html = vehicleHtml(p, v) + bulbHint(p, v);
      if (html) { host.innerHTML = html; host.classList.add('dn-page-on'); }
      host.addEventListener('click', function (e) {
        var b = e.target.closest && e.target.closest('.dn-chip');
        if (b) { e.preventDefault(); location.href = searchUrl(b.getAttribute('data-q')); }
      });
    });
  }

  function boot() {
    var run = function () {
      Array.prototype.forEach.call(document.querySelectorAll('form[action$="/search"]'), initForm);
      initPage();
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
  }

  return { norm: norm, tokens: tokens, parse: parse, findVehicles: findVehicles, productOk: productOk, rankProducts: rankProducts, shopifyQuery: shopifyQuery, boot: boot, _set: function (d) { g.DN_VEH = d; cache = null; } };
});
